/**
 * Vipupisteet v2 in Työpaja (pivot_points.v2, admin.section). Candidates are
 * found, accepted and dismissed on the v2 screen itself (/pivotpoints-v2);
 * this panel shows where the latest run stands and opens the screen. It does
 * not reuse v1's PivotPointContent, which drives the v1 endpoints.
 */
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Compass } from 'lucide-react';
import API_ENDPOINTS from '../../../config/api';
import { useTranslation } from '../../../hooks/useTranslation.jsx';
import { Card, Facts, Actions, ActionLink, Muted, ErrorText } from './moduleSectionStyles';

export default function PivotPointsV2Content({ instanceId }) {
  const { t } = useTranslation();
  const [state, setState] = useState({ loaded: false, run: null, candidates: [], error: null });

  useEffect(() => {
    if (!instanceId) return undefined;
    let cancelled = false;
    fetch(API_ENDPOINTS.RAG_PIVOTS_V2_LATEST(instanceId))
      .then((r) => { if (!r.ok) throw new Error(`HTTP ${r.status}`); return r.json(); })
      .then((d) => { if (!cancelled) setState({ loaded: true, run: d.run, candidates: d.candidates || [], error: null }); })
      .catch((err) => { if (!cancelled) setState({ loaded: true, run: null, candidates: [], error: err.message }); });
    return () => { cancelled = true; };
  }, [instanceId]);

  const count = (status) => state.candidates.filter((c) => c.status === status).length;

  return (
    <Card>
      <Muted>{t('pivotsV2Step.intro')}</Muted>
      {state.error && <ErrorText>{t('pivotsV2Step.loadFailed', { error: state.error })}</ErrorText>}
      {state.loaded && !state.error && (
        state.run ? (
          <Facts>
            <dt>{t('pivotsV2Step.accepted')}</dt><dd>{count('accepted')}</dd>
            <dt>{t('pivotsV2Step.proposed')}</dt><dd>{count('proposed')}</dd>
            <dt>{t('pivotsV2Step.dismissed')}</dt><dd>{count('dismissed')}</dd>
          </Facts>
        ) : (
          <Muted>{t('pivotsV2Step.noRun')}</Muted>
        )
      )}
      <Actions>
        <ActionLink as={Link} to={`/pivotpoints-v2?instance=${instanceId}`} $primary>
          <Compass size={16} /> {t('pivotsV2Step.open')}
        </ActionLink>
      </Actions>
    </Card>
  );
}
